var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5C16.1046 5 17 5.89543 17 7V8H19C20.1046 8 21 8.89543 21 10V17C21 18.1046 20.1046 19 19 19H9C7.89543 19 7 18.1046 7 17V16H5C3.89543 16 3 15.1046 3 14V7C3 5.89543 3.89543 5 5 5H15ZM9 9C8.44772 9 8 9.44772 8 10V17C8 17.5523 8.44772 18 9 18H19C19.5523 18 20 17.5523 20 17V10C20 9.44772 19.5523 9 19 9H9ZM5 6C4.44772 6 4 6.44772 4 7V14C4 14.5523 4.44772 15 5 15H7V10C7 8.89543 7.89543 8 9 8H16V7C16 6.44772 15.5523 6 15 6H5ZM15.5 13C15.7761 13 16 13.2239 16 13.5C16 13.7761 15.7761 14 15.5 14H10.5C10.2239 14 10 13.7761 10 13.5C10 13.2239 10.2239 13 10.5 13H15.5ZM17.5 11C17.7761 11 18 11.2239 18 11.5C18 11.7761 17.7761 12 17.5 12H10.5C10.2239 12 10 11.7761 10 11.5C10 11.2239 10.2239 11 10.5 11H17.5Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.8050c72691fa625fd310b8970c07a8a3.svg";
export { ForwardRef as ReactComponent };